const v8 = (state: any) => {
  return {
    ...state,
    options: {
      ...state.options,
      tableViews: {
        ...state.options.tableViews,
        videosTable: {
          ...state.options.tableViews.videosTable,
          Duration: true,
        },
      },
    },
  };
};

export default v8;
